import React from "react";

interface AddButtonProps {
  id: string;
  onClick: () => void;
}
const AddButton = ({ id, onClick }: AddButtonProps) => {
  return (
    <button
      id={id}
      type="button"
      onClick={onClick}
      className="btn btn-soft-primary btn-sm"
    >
      <i className="bx bx-plus"></i>
    </button>
  );
};

export default AddButton;